import { useState, useEffect, useCallback } from 'react';
import { RefreshCw, RotateCcw } from 'lucide-react';
import { VERTICAL_KEYS, VERTICAL_LABELS, ROLE_KEYS, ROLE_LABELS, SECTORES, ESCALAS, MODALIDADES } from './constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const sel = 'bg-white/5 border border-white/10 rounded px-2.5 py-1.5 text-white text-xs outline-none';

export default function Catalogo({ token, initialFilter }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ vertical: '', rol: '', sector: '', escala: '', modalidad: '' });

  useEffect(() => { if (initialFilter) setF((p) => ({ ...p, ...initialFilter })); }, [initialFilter]);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await fetch(`${BACKEND_URL}/api/admin/catalogo`, { headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) setItems((await res.json()).catalogo);
    setLoading(false);
  }, [token]);
  useEffect(() => { load(); }, [load]);

  const filtered = items.filter((c) => {
    if (f.vertical && c[f.vertical] !== 'Acreditada') return false;
    if (f.rol && !['Referencia', 'Solido'].includes(c[f.rol])) return false;
    if (f.sector && !(c.sectores || []).includes(f.sector)) return false;
    if (f.escala && c.escala_dominante !== f.escala) return false;
    if (f.modalidad && c.modalidad !== f.modalidad) return false;
    return true;
  });

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2.5 mb-5">
        <select className={sel} value={f.vertical} onChange={(e) => setF((p) => ({ ...p, vertical: e.target.value }))} data-testid="cat-filter-vertical">
          <option value="">Vertical</option>{VERTICAL_KEYS.map((k) => <option key={k} value={k}>{VERTICAL_LABELS[k]}</option>)}
        </select>
        <select className={sel} value={f.rol} onChange={(e) => setF((p) => ({ ...p, rol: e.target.value }))}>
          <option value="">Rol</option>{ROLE_KEYS.map((k) => <option key={k} value={k}>{ROLE_LABELS[k]}</option>)}
        </select>
        <select className={sel} value={f.sector} onChange={(e) => setF((p) => ({ ...p, sector: e.target.value }))}>
          <option value="">Sector</option>{SECTORES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <select className={sel} value={f.escala} onChange={(e) => setF((p) => ({ ...p, escala: e.target.value }))}>
          <option value="">Escala</option>{ESCALAS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <select className={sel} value={f.modalidad} onChange={(e) => setF((p) => ({ ...p, modalidad: e.target.value }))}>
          <option value="">Modalidad</option>{MODALIDADES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <button onClick={load} className="p-1.5 rounded hover:bg-white/10 text-white/50"><RefreshCw size={14} className={loading ? 'animate-spin' : ''} /></button>
      </div>

      {filtered.length === 0 ? <p className="text-white/30 text-sm py-12 text-center">No hay advisors en el catálogo</p> : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="catalogo-grid">
          {filtered.map((c) => (
            <div key={c.id} className="border border-white/10 rounded p-4 bg-white/[0.02]">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="text-white text-sm font-medium">{c.nombre}</span>
                  <span className="text-white/30 text-[10px] font-mono">{c.id}</span>
                </div>
                {c.computed.needs_revalidacion && <span className="text-amber-400 text-[10px] flex items-center gap-1"><RotateCcw size={11} />Revalidar</span>}
              </div>
              <p className="text-[#C58C40] text-xs mb-2">{c.nivel_asignado || '—'}</p>
              <p className="text-white/90 text-sm leading-snug mb-3">{c.activo_diferencial || '—'}</p>
              <div className="flex flex-wrap gap-1.5 mb-2">
                {VERTICAL_KEYS.filter((k) => c[k] === 'Acreditada').map((k) => (
                  <span key={k} className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-400/10 text-emerald-300">{VERTICAL_LABELS[k].split(' · ')[0]}</span>
                ))}
                {ROLE_KEYS.filter((k) => c[k] === 'Referencia').map((k) => (
                  <span key={k} className="text-[10px] px-1.5 py-0.5 rounded bg-[#C58C40]/15 text-[#C58C40]">{ROLE_LABELS[k].split(' · ')[0]}</span>
                ))}
              </div>
              <p className="text-white/40 text-[11px]">{(c.sectores || []).join(', ') || '—'} · {c.escala_dominante || '—'} · {c.rango_honorarios || '—'} · {c.horas_mes ? `${c.horas_mes}h/mes` : '—'} · {c.modalidad || '—'}</p>
            </div>
          ))}
        </div>
      )}
      <p className="text-white/25 text-xs mt-3">{filtered.length} advisor(s)</p>
    </div>
  );
}
